import * as type from './type';
/* eslint-disable */
export default {
  [type.GET_USER_INFO]: state => {
    return state.userInfo || {};
  },
  [type.GET_TOKEN]: state => {
    return state.token || '';
  }
};



// WEBPACK FOOTER //
// ./src/store/getters/index.js